import { t } from 'i18next'

import { FormGroup, Input, Label } from '~/components/unform'

export const ImageFields = ({
  onChange
}: {
  onChange: (value: OnChangeInputData) => void
}) => (
  <>
    <FormGroup>
      <Label
        text={t('rm:adsize.form.text.width')}
        htmlFor="width"
        helperText={t('rm:adsize.form.helpText.width')}
        isRequired
      />
      <Input
        name="width"
        type="number"
        min={0}
        htmlRightIcon={<code>px</code>}
        required
        onChange={onChange}
      />
    </FormGroup>

    <FormGroup>
      <Label
        text={t('rm:adsize.form.text.height')}
        htmlFor="height"
        helperText={t('rm:adsize.form.helpText.height')}
        isRequired
      />
      <Input
        name="height"
        type="number"
        min={0}
        htmlRightIcon={<code>px</code>}
        required
        onChange={onChange}
      />
    </FormGroup>
  </>
)
